module.exports = __webpack_public_path__ + "static/sb-hero-eddda966fb4f7d883faff0847befbdf0.jpg";